import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { CommandPaletteProvider } from '@shared/components/ui/CommandPaletteProvider';

/**
 * Post-image-review architecture (Apr 2026):
 * - No right-edge Assistant slide-over.
 * - No right-edge Agent panel.
 * - AI workspace = middle/central canvas only (Smart Match, record tabs).
 * - Command Palette = pure find/action overlay, keyboard-triggered.
 */
export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <CommandPaletteProvider>
      <div className="flex h-[100dvh] min-h-0 w-full font-sans overflow-hidden vscode-bg-secondary vscode-transition">
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-20 bg-black/60 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <div className="shrink-0 lg:flex lg:h-full lg:min-h-0 lg:flex-col">
          <Sidebar
            open={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />
        </div>

        <div className="flex min-h-0 min-w-0 flex-1 overflow-hidden border-l vscode-border">
          <div className="flex min-h-0 min-w-0 flex-1 flex-col">
            <Topbar onMenuClick={() => setSidebarOpen(true)} />
            <main className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden p-4 lg:p-6 vscode-bg-primary">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </CommandPaletteProvider>
  );
}
